import React from 'react'

// material ui forms
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'

// shared components
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'
import StepHeader from 'components/atoms/StepHeader'

const SeatingPreferenceForm = props => {
  const {
    setModal, // passed in from AllergiesForm
    form, // via redux state
    formErrors, // via withFormResults

    // via CamperFormContainer:
    onChangeBooleanStringField // via withEventHandlers
  } = props

  return (
    <>
      <FormControlWithErrorHelper
        component='fieldset'
        required
        errorsObject={formErrors}
        errorField='sitsSeparately'
        setModal={setModal}
      >
        <FormLabel required={false} htmlFor='sitsSeparately' component='legend'>
          <StepHeader
            setModal={setModal}
            modalId='sitsSeparately'
            variant='body1'
          >
            I would like my child to eat lunch away from other campers due to a
            food allergy.
          </StepHeader>
        </FormLabel>
        <RadioGroup
          value={String(form.sitsSeparately)}
          onChange={onChangeBooleanStringField('sitsSeparately')}
          aria-label='sit separate'
          name='sitsSeparately'
          id='sitsSeparately'
        >
          <FormControlLabel value='true' control={<Radio />} label='Yes' />
          <FormControlLabel value='false' control={<Radio />} label='No' />
        </RadioGroup>
      </FormControlWithErrorHelper>
    </>
  )
}

export default SeatingPreferenceForm
